import { useEffect, useRef, useState } from 'react';
import {
    FormControl, Chip, InputLabel, Select, MenuItem, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Breadcrumbs,
    CircularProgress, Link, IconButton, Card, CardContent, Tooltip, InputAdornment, useTheme
} from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import axiosInstance from '../../../../lib/axios';
import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import { getRoomMasterdropdata } from '../../../../Api/PropertyMst/Api';
import { getShiftMasterdropdata } from '../../../../Api/PropertyMst/Api';
import HomeIcon from '@mui/icons-material/Home';
import PrintIcon from '@mui/icons-material/Print';
import SearchIcon from '@mui/icons-material/Search';
import { useReactToPrint } from 'react-to-print';
import PrintPage from './PrintPage';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useSelector } from 'react-redux';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';

const Menpower = () => {
    const [formData, setFormData] = useState({
        Property: '',
        Shift: '',
        DateField: new Date().toISOString().split('T')[0],
        remark: ''
    });
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation()
    const userId = sessionStorage.getItem('UserId');
    const [dropdownData, setDropdownData] = useState([]);
    const [selectedProperty, setSelectedProperty] = useState([])
    const [shiftData, setShiftData] = useState([])
    const [fetchedData, setFetchedData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showGrid, setShowGrid] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [filteredRecords, setFilteredRecords] = useState([]);
    const contentRef = useRef(null);
    const [worker, setWorker] = useState()
    const globalProperty = useSelector(selectGlobalProperty);
    const [mode, setMode] = useState('view');
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [isStateDataLoading, setIsStateDataLoading] = useState(false);

    const handlePrint = useReactToPrint({
        contentRef,
        documentTitle: `Manpower_${formData.Property}_${formData.DateField}_${formData.Shift}`
    });

    const formatedDate = (dateString) => {
        if (!dateString) return '';

        const date = new Date(dateString);
        if (isNaN(date.getTime())) return dateString;

        return date.toLocaleDateString('en-GB');
    };

    useEffect(() => {
        if (globalProperty && globalProperty !== formData.Property) {
            setFormData(prevState => ({
                ...prevState,
                Property: globalProperty.toString()
            }));
        }
    }, [globalProperty]);

    useEffect(() => {
        const fetchDataFromState = async () => {
            const state = location.state;
            if (state) {
                setIsStateDataLoading(true);
                setShowGrid(false);
                if (state.mode) {
                    setMode(state.mode);
                    const viewMode = state.mode === 'view';
                    setIsFormDisabled(viewMode);
                }

                let propId = null;
                let shiftId = null;
                let mdpDt = null;

                if (state.PropId) {
                    propId = state.PropId.toString();
                }

                if (state.ShiftId) {
                    shiftId = state.ShiftId.toString();
                }

                if (state.MdpDt) {
                    let dateValue = state.MdpDt;

                    if (dateValue.match(/^\d{2}-\d{2}-\d{4}$/)) {
                        const [day, month, year] = dateValue.split('-');
                        mdpDt = `${year}-${month}-${day}`;
                    }
                    else if (dateValue.match(/^\d{2}\/\d{2}\/\d{4}$/)) {
                        const [day, month, year] = dateValue.split('/');
                        mdpDt = `${year}-${month}-${day}`;
                    }

                    else if (dateValue.match(/^\d{2}\/\d{2}\/\d{4}$/) && dateValue.split('/')[0] > 12) {
                        const [month, day, year] = dateValue.split('/');
                        mdpDt = `${year}-${month}-${day}`;
                    }
                    else {

                        const parsedDate = new Date(dateValue);
                        if (!isNaN(parsedDate.getTime())) {
                            mdpDt = parsedDate.toISOString().split('T')[0];
                        } else {
                            mdpDt = dateValue;
                        }
                    }
                }

                const waitForDropdowns = async () => {

                    if (propId && dropdownData.length === 0) {
                        await new Promise(resolve => {
                            const checkInterval = setInterval(() => {
                                if (dropdownData.length > 0) {
                                    clearInterval(checkInterval);
                                    resolve();
                                }
                            }, 100);
                            setTimeout(() => {
                                clearInterval(checkInterval);
                                resolve();
                            }, 3000);
                        });
                    }

                    if (shiftId && shiftData.length === 0) {
                        await new Promise(resolve => {
                            const checkInterval = setInterval(() => {
                                if (shiftData.length > 0) {
                                    clearInterval(checkInterval);
                                    resolve();
                                }
                            }, 100);
                            setTimeout(() => {
                                clearInterval(checkInterval);
                                resolve();
                            }, 3000);
                        });
                    }

                    if (propId) {
                        setFormData(prev => ({ ...prev, Property: propId }));
                    }
                    if (shiftId) {
                        setFormData(prev => ({ ...prev, Shift: shiftId }));
                    }
                    if (mdpDt) {
                        setFormData(prev => ({ ...prev, DateField: mdpDt }));
                    }
                    if (state.Remark) {
                        setFormData(prev => ({ ...prev, remark: state.Remark }));
                    }

                    if (propId && shiftId && mdpDt) {
                        setTimeout(async () => {
                            setIsLoading(true);
                            setShowGrid(true);
                            try {
                                const response = await axiosInstance.post('TrnMdp/RetriveTrnMdpAll', {
                                    PropId: parseInt(propId),
                                    ShiftId: parseInt(shiftId),
                                    MdpDt: mdpDt,
                                    MdpId: 0,
                                    Flag: "R"
                                });

                                if (response.data.Status === 0) {
                                    const rawHeader = response.data.Data.TrnMdpDtlEntities[0];
                                    const details = rawHeader?.MdpdtlEntities || [];

                                    const apiTotals = {};
                                    details.forEach(item => {
                                        const typeName = item.HkWrkTypeName?.trim();
                                        if (typeName) {
                                            if (!apiTotals[typeName]) {
                                                apiTotals[typeName] = 0;
                                            }
                                            apiTotals[typeName] += parseFloat(item.AttnWorker) || 0;
                                        }
                                    });
                                    setWorker(apiTotals);

                                    const mainMdpId = rawHeader?.MdpId || 0;
                                    const groupedByStation = details.reduce((acc, item) => {
                                        const stationName = item.HkWrkStnName;

                                        if (!acc[stationName]) {
                                            acc[stationName] = {
                                                HkWrkStnId: item.HkWrkStnId,
                                                HkWrkStnName: stationName,
                                                workerTypes: []
                                            };
                                        }

                                        acc[stationName].workerTypes.push({
                                            HkWrkrTypeId: item.HkWrkrTypeId,
                                            HkWrkTypeName: item.HkWrkTypeName?.trim() || `Worker Type ${item.HkWrkrTypeId}`,
                                            DplyWrkr: item.DplyWrkr ?? 0,
                                            AttnWorker: item.AttnWorker || 0,
                                            Remark: item.Remark || "",
                                            MdpDtlId: item.MdpDtlId || 0,
                                            MdpId: mainMdpId
                                        });

                                        return acc;
                                    }, {});

                                    const transformedData = Object.values(groupedByStation);
                                    setFetchedData(transformedData);
                                    setShowGrid(true);
                                } else {
                                    toast.error(response.data.Message);
                                    setFetchedData([]);
                                    setShowGrid(true);
                                }
                            } catch (error) {
                                toast.error('Error fetching data. Please try again.');
                                setFetchedData([]);
                                setShowGrid(false);
                            } finally {
                                setIsLoading(false);
                                setIsStateDataLoading(false);
                            }
                        }, 100);
                    }
                    else {
                        setIsStateDataLoading(false);
                    }
                };
                waitForDropdowns();
            }
        };

        fetchDataFromState();
    }, [location.state, dropdownData, shiftData]);

    const handleHomeClick = () => {
        navigate('/dashboard');
    };

    const handleLocationClick = () => {
        navigate('/operations/housekeepin');
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const response = await getRoomMasterdropdata({
                    Flag: "",
                    UserId: userId,
                });
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data?.map((item) => ({
                        id: item.PropId,
                        name: item.Name,
                    }));
                    setDropdownData(dropdownItems);
                    if (!location.state?.PropId) {
                        if (globalProperty) {
                            const globalPropExists = dropdownItems.find(item =>
                                item.id.toString() === globalProperty.toString()
                            );
                            if (globalPropExists) {
                                setFormData(prev => ({
                                    ...prev,
                                    Property: globalProperty.toString()
                                }));
                            } else if (dropdownItems.length > 0) {
                                setFormData(prev => ({
                                    ...prev,
                                    Property: dropdownItems[0].id.toString()
                                }));
                            }
                        } else if (dropdownItems.length > 0) {
                            setFormData(prev => ({
                                ...prev,
                                Property: dropdownItems[0].id.toString()
                            }));
                        }
                    }
                }
            } catch (error) {
                toast.error("Error fetching property data");
            }
        };
        fetchDropdownData();
    }, [userId, globalProperty, location.state]);

    useEffect(() => {
        const fetchShiftData = async () => {
            try {
                const response = await getShiftMasterdropdata();
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.ShiftId,
                        name: item.ShiftName,
                    }));
                    setShiftData(dropdownItems);
                    if (!location.state?.ShiftId && dropdownItems.length > 0) {
                        setFormData(prev => ({ ...prev, Shift: dropdownItems[0].id }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching shift data");
            }
        };
        fetchShiftData();
    }, [location.state]);

    useEffect(() => {
        const lowerSearchText = searchText.toLowerCase();
        const filtered = fetchedData.filter((station) =>
            station.HkWrkStnName?.toLowerCase().includes(lowerSearchText) ||
            station.workerTypes.some(type =>
                type.DplyWrkr?.toString().includes(lowerSearchText) ||
                type.Remark?.toLowerCase().includes(lowerSearchText) ||
                type.HkWrkTypeName?.toLowerCase().includes(lowerSearchText)
            )
        );
        setFilteredRecords(filtered);
    }, [searchText, fetchedData]);

    const handleGetData = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.post('TrnMdp/RetriveTrnMdpAll', {
                PropId: parseInt(formData.Property),
                ShiftId: parseInt(formData.Shift),
                MdpDt: formData.DateField,
                MdpId: 0,
                Flag: "R"
            });

            if (response.data.Status === 0) {
                const rawHeader = response.data.Data.TrnMdpDtlEntities[0];
                const details = rawHeader?.MdpdtlEntities || [];
                const apiTotals = {};
                details.forEach(item => {
                    const typeName = item.HkWrkTypeName?.trim();
                    if (typeName) {
                        if (!apiTotals[typeName]) {
                            apiTotals[typeName] = 0;
                        }
                        apiTotals[typeName] += parseFloat(item.AttnWorker) || 0;
                    }
                });

                setWorker(apiTotals);
                const mainMdpId = rawHeader?.MdpId || 0;

                const groupedByStation = details.reduce((acc, item) => {
                    const stationName = item.HkWrkStnName;

                    if (!acc[stationName]) {
                        acc[stationName] = {
                            HkWrkStnId: item.HkWrkStnId,
                            HkWrkStnName: stationName,
                            workerTypes: []
                        };
                    }

                    acc[stationName].workerTypes.push({
                        HkWrkrTypeId: item.HkWrkrTypeId,
                        HkWrkTypeName: item.HkWrkTypeName?.trim() || `Worker Type ${item.HkWrkrTypeId}`,
                        DplyWrkr: item.DplyWrkr ?? 0,
                        AttnWorker: item.AttnWorker || 0,
                        Remark: item.Remark || "",
                        MdpDtlId: item.MdpDtlId || 0,
                        MdpId: mainMdpId
                    });

                    return acc;
                }, {});

                const transformedData = Object.values(groupedByStation);
                setFetchedData(transformedData);
                setShowGrid(true);
            } else {
                toast.error(response.data.Message);
                setFetchedData([]);
                setShowGrid(false);
            }
        } catch (error) {
            toast.error('Error fetching data. Please try again.');
            setFetchedData([]);
            setShowGrid(false);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSaveData = async () => {
        if (!fetchedData.length) {
            toast.error('No data to save');
            return;
        }
        const workerLimits = {};
        fetchedData.forEach(station => {
            station.workerTypes.forEach(type => {
                const typeName = type.HkWrkTypeName;
                if (typeName) {
                    if (!workerLimits[typeName]) {
                        workerLimits[typeName] = type.AttnWorker || 0;
                    } else {
                        workerLimits[typeName] = Math.max(
                            workerLimits[typeName],
                            type.AttnWorker || 0
                        );
                    }
                }
            });
        });

        const currentTotals = {};
        fetchedData.forEach(station => {
            station.workerTypes.forEach(type => {
                const typeName = type.HkWrkTypeName;
                if (!currentTotals[typeName]) {
                    currentTotals[typeName] = 0;
                }
                currentTotals[typeName] += parseFloat(type.DplyWrkr) || 0;
            });
        });
        let hasError = false;
        let errorMessage = '';

        Object.keys(currentTotals).forEach(typeName => {
            const currentTotal = currentTotals[typeName];
            const apiLimit = workerLimits[typeName] || 0;

            if (currentTotal > apiLimit) {
                hasError = true;
                errorMessage = `Cannot deploy more than ${apiLimit} workers for ${typeName}. You have entered ${currentTotal}.`;
            }
        });

        if (hasError) {
            toast.error(errorMessage);
            return;
        }
        setIsLoading(true);

        try {

            const mainMdpId = fetchedData[0]?.workerTypes[0]?.MdpId || 0;
            const hasExistingDetail = fetchedData.some(station =>
                station.workerTypes.some(type => type.MdpDtlId > 0)
            );

            const trnMdpdtlEntities = fetchedData.flatMap(station =>
                station.workerTypes.map(type => ({
                    DBFLAG: type.MdpDtlId > 0 ? "U" : "I",
                    MdpDtlId: type.MdpDtlId || 0,
                    MdpId: mainMdpId,  // Real MdpId
                    HkWrkStnId: station.HkWrkStnId,
                    HkWrkrTypeId: type.HkWrkrTypeId,
                    DplyWrkr: type.DplyWrkr || 0,
                    Remark: type.Remark || formData.remark || ""
                }))
            );

            const payload = {
                DBFLAG: hasExistingDetail ? "U" : "I",
                MdpId: hasExistingDetail ? mainMdpId : 0,
                MdpNo: "",
                PropId: parseInt(formData.Property),
                MdpDt: formData.DateField,
                ShiftId: parseInt(formData.Shift),
                Remark: formData.remark || "",
                Status: "1",
                Created_By: parseInt(userId),
                trnMdpdtlEntities
            };

            const response = await axiosInstance.post('TrnMdp/MangeTrnMdp', payload);

            if (response.data.Status === 0) {
                toast.success(response.data.Message || 'Data saved successfully!');
                await handleGetData();
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || 'Error saving data');
            }
        } catch (error) {
            toast.error(error.response?.data?.Message || 'Failed to save.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
    };

    const handleCancel = () => {
        setMode('view');
        setIsFormDisabled(true);
    };

    const handleEdit = () => {
        setMode('add');
        setIsFormDisabled(false);
    };

    const handleExit = () => {
        navigate('/operations/menpowertable');
    };

    const renderCardView = () => {
        const dataToShow = searchText ? filteredRecords : fetchedData;
        if (!dataToShow.length) return null;

        return (
            <Grid container spacing={2} sx={{ marginTop: '1px', px: 1 }}>
                {dataToShow.map((station, displayIndex) => {
                    const originalStationIndex = fetchedData.findIndex(s => s.HkWrkStnId === station.HkWrkStnId);

                    return (
                        <Grid item xs={12} md={6} lg={2.4} key={station.HkWrkStnId}>
                            <Card
                                sx={{
                                    boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.1)',
                                    borderRadius: 2,
                                    height: '100%',
                                    transition: 'all 0.3s ease',
                                    border: '1px solid #e0e0e0',
                                    '&:hover': {
                                        boxShadow: '0 8px 24px 0 rgba(0, 0, 0, 0.15)',
                                        transform: 'translateY(-2px)'
                                    }
                                }}
                            >
                                <CardContent sx={{ p: 0 }}>
                                    <Box
                                        sx={{
                                            background: '#e3f2fd',
                                            color: 'black',
                                            p: 1,
                                            borderTopLeftRadius: 8,
                                            borderTopRightRadius: 8,
                                            position: 'relative',
                                            overflow: 'hidden',
                                            '&::before': {
                                                content: '""',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                height: '2px',
                                                background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)'
                                            }
                                        }}
                                    >
                                        <Typography
                                            variant="p"
                                            component="div"
                                            sx={{
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                                fontSize: '0.9rem',
                                                textShadow: '0 1px 2px rgba(0,0,0,0.2)',
                                                letterSpacing: '0.5px'
                                            }}
                                        >
                                            WorkStation → <span>{station.HkWrkStnName}</span>
                                        </Typography>
                                    </Box>
                                    <TableContainer>
                                        <Table size="small" sx={{ minWidth: 200 }}>
                                            <TableHead>
                                                <TableRow sx={{ height: 32 }}>
                                                    <TableCell sx={{ fontWeight: 'bold', background: '#f8f9fa', py: 0.5, px: 1, fontSize: '0.8rem', width: '42%' }}>
                                                        Worker Type
                                                    </TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold', background: '#f8f9fa', py: 0.5, px: 1, fontSize: '0.8rem', width: '23%' }}>
                                                        Workers
                                                    </TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold', background: '#f8f9fa', py: 0.5, px: 1, fontSize: '0.8rem', width: '35%' }}>
                                                        Remark
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {station.workerTypes.map((type, typeDisplayIndex) => {
                                                    const originalTypeIndex = fetchedData[originalStationIndex]?.workerTypes
                                                        .findIndex(t => t.HkWrkrTypeId === type.HkWrkrTypeId);

                                                    return (
                                                        <TableRow key={type.HkWrkrTypeId} sx={{ height: 28 }}>
                                                            <TableCell
                                                                sx={{
                                                                    fontWeight: '600',
                                                                    borderRight: '1px solid #e8e8e8',
                                                                    px: 1,
                                                                    py: 0.5,
                                                                    fontSize: '0.8rem',
                                                                    color: '#34495e',
                                                                    width: '42%'
                                                                }}
                                                            >
                                                                {type.HkWrkTypeName}
                                                            </TableCell>
                                                            <TableCell sx={{ borderRight: '1px solid #e8e8e8', px: 1, py: 0.5, width: '23%' }}>
                                                                <TextField
                                                                    type="number"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    value={type.DplyWrkr}
                                                                    onChange={(e) => {
                                                                        const updated = [...fetchedData];
                                                                        updated[originalStationIndex].workerTypes[originalTypeIndex].DplyWrkr = parseFloat(e.target.value) || 0;
                                                                        setFetchedData(updated);
                                                                    }}
                                                                    inputProps={{
                                                                        min: 0,
                                                                        step: "any",
                                                                        style: { textAlign: 'center', padding: '1px 4px', fontSize: '0.8rem', height: '18px', fontWeight: '500' }
                                                                    }}
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            height: '22px',
                                                                            '& input': { padding: '1px 4px', height: '18px' },
                                                                            '& fieldset': { border: '1px solid #ddd', borderRadius: '6px' },
                                                                            '&:hover fieldset': { border: '1px solid #667eea', boxShadow: '0 0 0 2px rgba(102, 126, 234, 0.1)' },
                                                                            '&.Mui-focused fieldset': { border: '2px solid #667eea', boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.1)' }
                                                                        }
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ py: 0.5, px: 1, width: '30%' }}>
                                                                <TextField
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    placeholder="Enter remark..."
                                                                    value={type.Remark}
                                                                    onChange={(e) => {
                                                                        const updated = [...fetchedData];
                                                                        updated[originalStationIndex].workerTypes[originalTypeIndex].Remark = e.target.value;
                                                                        setFetchedData(updated);
                                                                    }}
                                                                    inputProps={{
                                                                        style: { padding: '1px 4px', fontSize: '0.8rem', height: '20px' }
                                                                    }}
                                                                    sx={{
                                                                        '& .MuiOutlinedInput-root': {
                                                                            height: '22px',
                                                                            '& input': { padding: '1px 4px', height: '18px' },
                                                                            '& fieldset': { border: '1px solid #ddd', borderRadius: '6px' },
                                                                            '&:hover fieldset': { border: '1px solid #667eea', boxShadow: '0 0 0 2px rgba(102, 126, 234, 0.1)' },
                                                                            '&.Mui-focused fieldset': { border: '2px solid #667eea', boxShadow: '0 0 0 3px rgba(102, 126, 234, 0.1)' }
                                                                        }
                                                                    }}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </CardContent>
                            </Card>
                        </Grid>
                    );
                })}
            </Grid>
        );
    };

    return (
        <>
            <Box sx={{ px: 2, pb: 2 }}>
                <ToastContainer />
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                backgroundColor: "#ffffff",
                                padding: { xs: "10px 16px", sm: "12px 20px" },
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.06)",
                                borderRadius: "12px",
                                margin: "12px 20px",
                                maxWidth: "calc(100% - 40px)",
                                flexDirection: { xs: "column", md: "row" },
                                gap: { xs: 2, md: 3 },
                            }}
                        >
                            <Breadcrumbs
                                aria-label="breadcrumb"
                                separator="›"
                                sx={{
                                    fontSize: { xs: "14px", sm: "15px", md: "16px" },
                                }}
                            >
                                <Link
                                    underline="hover"
                                    color="#635bff"
                                    sx={{ cursor: "pointer", fontWeight: "500", display: "flex", alignItems: "center" }}
                                    onClick={handleHomeClick}
                                >
                                    <HomeIcon sx={{ mr: 0.5, fontSize: "inherit" }} />
                                    <Box component="span">Home</Box>
                                </Link>
                                <Link
                                    underline="hover"
                                    color="#635bff"
                                    sx={{ cursor: "pointer", fontWeight: "500" }}
                                    onClick={handleLocationClick}
                                >
                                    Operations
                                </Link>
                                <Typography color="text.primary" sx={{ fontWeight: "500" }}>
                                    Man Power
                                </Typography>
                            </Breadcrumbs>

                            <CrudButtons
                                moduleName="Man Power Deployment"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onExit={handleExit}
                                readOnlyMode={isFormDisabled}
                            />
                        </Box>
                    </Grid>

                    <Grid item xs={12} sx={{ margin: '0px 20px', boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`, borderRadius: '8px' }}>
                        <Grid container spacing={1} justifyContent='start' sx={{ padding: '20px 10px' }}>
                            <Grid item xs={12} md={2.5} lg={2.5}>
                                <FormControl variant="filled" fullWidth className="custom-textfield">
                                    <InputLabel id="property-label">Property</InputLabel>
                                    <Select
                                        labelId="property-label"
                                        id="Property"
                                        name="Property"
                                        value={formData.Property}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                    >
                                        {dropdownData.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2.2} lg={2}>
                                <FormControl variant="filled" fullWidth className="custom-textfield">
                                    <InputLabel id="shift-label">Shift</InputLabel>
                                    <Select
                                        labelId="shift-label"
                                        id="Shift"
                                        name="Shift"
                                        value={formData.Shift}
                                        onChange={handleInputChange}
                                        disabled={isFormDisabled}
                                    >
                                        {shiftData.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2.5} lg={1.5}>
                                <TextField
                                    id="DateField"
                                    name="DateField"
                                    label="Date"
                                    type="date"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.DateField}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={2.5} lg={3}>
                                <TextField
                                    id="remark"
                                    name="remark"
                                    label="Remark"
                                    type="text"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    disabled={isFormDisabled}
                                    value={formData.remark}
                                    onChange={handleInputChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={2.3} lg={2.3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Tooltip title='Retrieve Data' arrow>
                                    <Button
                                        variant="contained"
                                        onClick={handleGetData}
                                        disabled={isLoading || isFormDisabled}
                                        sx={{ minWidth: '100px', borderRadius: '20px', color: '#ffffff', bgcolor: '#635bff', ":hover": { bgcolor: '#635bff' } }}
                                    >
                                        Get Data
                                    </Button>
                                </Tooltip>
                                <Tooltip title='Insert/Update Records' arrow>
                                    {showGrid && fetchedData.length > 0 && (
                                        <Button
                                            variant="contained"
                                            color="success"
                                            onClick={handleSaveData}
                                            disabled={isFormDisabled}
                                            sx={{ minWidth: '100px', borderRadius: '20px' }}
                                        >
                                            Submit
                                        </Button>
                                    )}
                                </Tooltip>

                                <Button
                                    variant="outlined"
                                    color="error"
                                    onClick={handleCancel}
                                    disabled={isFormDisabled}
                                    sx={{ minWidth: '100px', borderRadius: '20px' }}
                                >
                                    Cancel
                                </Button>
                                {/* <Tooltip title='Print Records' arrow>
                                    {showGrid && fetchedData.length > 0 && (
                                        <Button
                                            variant="contained"
                                            sx={{ borderRadius: '20px' }}
                                            onClick={handlePrint}
                                        >
                                            <PrintIcon />
                                        </Button>
                                    )}
                                </Tooltip> */}
                            </Grid>
                        </Grid>
                    </Grid>

                    {showGrid && fetchedData.length > 0 && (
                        <>
                            <Grid item xs={12} sx={{ mt: 1, px: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexDirection: { xs: 'column', sm: 'row' }, }}>
                                    <Typography
                                        variant="h5"
                                        component="h4"
                                        sx={{
                                            fontWeight: 'bold',
                                            color: '#333',
                                            fontSize: { xs: '1rem', sm: '1.1rem' },
                                            whiteSpace: 'nowrap',
                                            marginLeft: '16px'
                                        }}
                                    >
                                        Manpower Deployment - {formatedDate(formData.DateField)}
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Search by Work Station, Worker etc."
                                        value={searchText}
                                        onChange={(e) => setSearchText(e.target.value)}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon sx={{ color: 'primary.main' }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                        sx={{
                                            maxWidth: 300,
                                            borderRadius: '16px',
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '16px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderRadius: '16px',
                                            },
                                            '& .MuiInputBase-input': {
                                                fontSize: '0.85rem',
                                                py: 0.8
                                            },
                                        }}
                                    />
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                                        {fetchedData.length > 0 && (() => {
                                            const workerTypeLimits = {};
                                            fetchedData.forEach(station => {
                                                station.workerTypes.forEach(type => {
                                                    const typeName = type.HkWrkTypeName;
                                                    if (typeName && !workerTypeLimits[typeName]) {
                                                        workerTypeLimits[typeName] = {
                                                            limit: type.AttnWorker || 0,
                                                            current: 0
                                                        };
                                                    }
                                                });
                                            });

                                            fetchedData.forEach(station => {
                                                station.workerTypes.forEach(type => {
                                                    const typeName = type.HkWrkTypeName;
                                                    if (workerTypeLimits[typeName]) {
                                                        workerTypeLimits[typeName].current += parseFloat(type.DplyWrkr) || 0;
                                                    }
                                                });
                                            });

                                            const chipColors = [
                                                { bg: '#4caf50', color: 'white' },
                                                { bg: '#f44336', color: 'white' },
                                            ];

                                            return Object.entries(workerTypeLimits).map(([typeName, data], index) => {
                                                const { current, limit } = data;
                                                const isExceeding = current > limit;
                                                const colorIndex = isExceeding ? 1 : 0;

                                                return (
                                                    <Chip
                                                        key={typeName}
                                                        label={`${typeName}: ${current}/${limit}`}
                                                        size="small"
                                                        sx={{
                                                            fontWeight: 'bold',
                                                            backgroundColor: chipColors[colorIndex].bg,
                                                            color: chipColors[colorIndex].color,
                                                            '& .MuiChip-label': {
                                                                px: 1,
                                                                py: 0.5,
                                                                fontSize: '0.8rem'
                                                            },
                                                            boxShadow: 1,
                                                            border: isExceeding ? '2px solid #ff5252' : 'none'
                                                        }}
                                                        title={isExceeding ? `Limit exceeded! Maximum allowed is ${limit}` : ''}
                                                    />
                                                );
                                            });
                                        })()}
                                    </Box>
                                </Box>
                            </Grid>

                            <Grid item xs={12} sx={{ px: 1 }}>
                                {renderCardView()}
                            </Grid>
                        </>
                    )}

                    {isStateDataLoading && (
                        <Grid item xs={12} sx={{ mt: 4, textAlign: 'center' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                                <CircularProgress size={40} />
                                <Typography variant="h6" color="text.secondary">
                                    Loading data...
                                </Typography>
                            </Box>
                        </Grid>
                    )}

                    {!isStateDataLoading && showGrid && fetchedData.length === 0 && (
                        <Grid item xs={12} sx={{ mt: 4, textAlign: 'center' }}>
                            <Typography variant="h6" color="text.secondary">
                                No data found for the selected criteria
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </Box>
            {showGrid && fetchedData.length > 0 && (
                <div style={{ display: 'none' }}>
                    <PrintPage
                        ref={contentRef}
                        fetchedData={fetchedData}
                        formData={formData}
                        propertyName={dropdownData.find(p => p.id === parseInt(formData.Property))?.name || ''}
                        shiftName={shiftData.find(s => s.id === parseInt(formData.Shift))?.name || ''}
                    />
                </div>
            )}
        </>
    );
};

export default Menpower;